import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classApi from "../../api/classApi";
import Button from "../../components/Button";
import CardClass from "../../components/CardClass";
import CreateClassPopup from "../../components/CreateClassPopup";
import Layout from "../../components/Layout";
import Title from "../../components/Title";
import { RootState } from "../../store";
import toast from "react-hot-toast";

function Class() {
    const [openPopup, setOpenPopup] = useState(false);
    const [listClass, setListClass] = useState([]);
    const handleClose = () => {
        setOpenPopup(false);
    };
    const handleCreateClass = () => {
        setOpenPopup(!openPopup);
    }
    const { user } = useSelector((state: RootState) => state.auth);
    console.log("user", user.roles);

    const [courseCode, setCourseCode] = useState("");

    const isStaff = user?.roles.includes("student_management") || user?.roles.includes("branch_manager") || user?.roles.includes("staff");
    const isStudent = user?.roles.includes("Học viên") || user?.roles.includes("student");
    const isTeacher = user?.roles.includes("Giảng viên") || user?.roles.includes("teacher");
    useEffect(() => {
        const code = (isTeacher || isStudent) ? user?.courses?.[0]?.code : "";
        setCourseCode(code);
    }, [user, isTeacher, isStudent]);
    const fetchData = async (courseCode: string) => {
        let res;
        if (courseCode === "") {
            res = await classApi.getAllClass({ page: 1 });
        } else {
            res = await classApi.getAllClass({ courseCode, page: 1 });
        }
        console.log("Res class", res)
        setListClass(res.data.items);
    };

    useEffect(() => {
        if (courseCode !== undefined) {
            fetchData(courseCode);
        }
    }, [courseCode]);

    const handleCreateClassSuccess = () => {
        // Tải lại danh sách lớp học sau khi tạo thành công
        setOpenPopup(false);
        toast.success("Tạo lớp học thành công")
        fetchData(courseCode);
    }
    console.log("isStaff", isStaff);
    return (
        <Layout>
            <CreateClassPopup onClose={handleClose} open={openPopup} onSuccess={handleCreateClassSuccess} />
            <section className="w-full h-fit py-[60px] px-[20px] lg:px-[50px] text-center bg-[#f9f9f9]">
                <Title title="Lớp Học" subTitle="Thông tin về các lớp học" />
                <div className="">
                    <div className={`${isStaff ? "block" : "hidden"} w-[20%] ml-auto`}>
                        <Button styleButton={`${isStaff ? "block" : "hidden"}`} type="button" label="+ Tạo lớp học" onClick={handleCreateClass} />
                    </div>
                    <div className="flex justify-start items-center flex-wrap gap-[20px] mt-[40px]">
                        {listClass.length > 0 && listClass.map((item: any) => (
                            <CardClass key={item.id} data={item} />
                        ))}
                    </div>
                </div>
            </section>
        </Layout>
    );
}

export default Class;